/**
 * hotbarSegmentSwatch — the CSS `background` for a Segment's swatch in a Hotbar
 * tab header (ImagesTab/VideosTab/... -> IconContainer bgColor).
 *
 * T22.180: the swatch used to be the Segment's base `settings.color` only. Once
 * a Gradient (or Pattern/Image/GIF) Segment Fill is picked, the wedge paints
 * that fill (createPie, via hydrateChartFill -> d.data.fill) while
 * `settings.color` keeps the OLD solid colour. Measured live on web-stg
 * (wheel 507651 + a copy of 507029): the filled Segment's wedge turned pink but
 * its Hotbar header kept a steel-blue swatch, so its images read as belonging to
 * "the Blue one" - a Segment that no longer looks blue on the Wheel.
 *
 * Resolve the swatch from the SAME fill model the wedge paints from
 * (resolveSegmentFill + buildSegmentFillCss), behind the SAME flag
 * (REACT_APP_SEGMENT_ARC_FILLS). No fill / flag OFF -> `settings.color`,
 * exactly as before.
 */
import { SEGMENT_ARC_FILLS_ENABLED } from "../D3Wheels/segmentArcFillsFlag";
import { resolveSegmentFill } from "../SegmentBuilder/Shared/SegmentStyling/logic/fillModelFeed";
import { buildSegmentFillCss } from "../SegmentBuilder/Shared/SegmentStyling/logic/segmentFill";

export const hotbarSegmentSwatch = (segment, enabled = SEGMENT_ARC_FILLS_ENABLED) => {
  const color = segment?.settings?.color;
  if (!enabled || !segment) return color;
  const fill = resolveSegmentFill(segment);
  if (!fill) return color;
  return buildSegmentFillCss(fill) || color;
};

export default hotbarSegmentSwatch;
